import { render, staticRenderFns } from "./DormComment.vue?vue&type=template&id=fb3c3b1c&"
import script from "./DormComment.vue?vue&type=script&lang=js&"
export * from "./DormComment.vue?vue&type=script&lang=js&"
import style0 from "./DormComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports